import React, {useEffect, useState} from 'react'
import {CardContent, CardHeader, List as ListUI, ListItem, ListItemText} from "@mui/material";
import {Panel} from "../../../../../Components";
import {useDispatch, useSelector} from "react-redux";
import {fetchRole, fetchRoles} from "../../Redux/Action";
import useDeepEqualSelector from "../../../../../Hooks/useDeepEqualSelector";
import { styled } from "@mui/material/styles";
import {setModal} from "../../../../Common/App";
import {RoleAssignedUserModal} from "../Modals/RoleAssignedUserModal";

const List = styled(ListUI)(({ theme }) => ({
    '& .MuiListItem-root': {
        borderBottom: '1px dashed #e0e0e0',
        '& .role-item': {
            display: 'flex',
            alignItems: 'center',
        },
        '& .role-user-count': {
            color: theme.palette.primary.main // Access the primary color from the theme
        },
        '& .role-user-count:hover': {
            color: theme.palette.error.main // Access the info color from the theme
        }
    },
}));

export const RolePanel = () => {

    const dispatch = useDispatch();
    const [, setHoveredItem] = useState(null);
    const items = useSelector((store) => store.roles.list);
    const pagination = useDeepEqualSelector((store) => store.roles?.config?.pagination);
    const [, setIsLoading] = React.useState(true);
    const [, setResponse] = React.useState({});

    useEffect(() => {
        fetchItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- intended: run when pagination changes
    },[pagination]);

    const fetchItems = async () => {
        setIsLoading(true);
        await fetchRoles({ dispatch, filters: {paginate:false, columns:['id','role_name','department'], withCount:'users'}}).then((res)=>{
            setResponse(res);
            setIsLoading(false);
        });
    }

    const primaryText = (item) => {
        return (
            <span
                className={'role-item'}
                style={{ cursor: 'pointer' }}
                onClick={() => handleRoleClick(item.id)} // handle click event
            >
                {item.role_name}
                    <span
                        onClick={() => handleClick(item.id)}
                        className='role-user-count'
                    >
                    {'(' + item.users_count + ')'}
                </span>
            </span>
            );
    };

    const handleRoleClick = async (itemId) => {
        await fetchRole({dispatch, id: itemId});
    }

    const handleClick = (itemId) => {
        // Handle click event
        dispatch(setModal({component:<RoleAssignedUserModal />, open:true}));
    }


    return (
        <Panel>
            <CardHeader title={"Roles"} />
            <CardContent>
                <List>
                    {items.map((item, index) => (
                        <ListItem
                            key={index}
                            onMouseEnter={() => setHoveredItem(index)} // Set hovered item index
                            onMouseLeave={() => setHoveredItem(null)} // Reset hovered item index
                        >
                            <ListItemText primary={primaryText(item)} secondary={item.department ?? '-'} />
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Panel>
    )
}